/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Audit_Email_OkInputs */

const fr_account_audit_email_ok = /** @type {(inputs: Account_Audit_Email_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email confirmé`)
};

/**

* @param {Account_Audit_Email_OkInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const account_audit_email_ok = /** @type {((inputs?: Account_Audit_Email_OkInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Audit_Email_OkInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_account_audit_email_ok(inputs)
});